function Footer() {
	return (
		<footer className="w-full border-t border-digitalWhite">
			<div className="py-2 bg-primary w-full flex flex-col justify-center text-white text-center">
				<font color="white">
					If you have any questions, please contact TSS at 780.492.2741 or by email at
					test.scoring@ualberta.ca
				</font>
				<br />
				<font color="white">Copyright © 2026 University of Alberta</font>
			</div>
		</footer>
	);
}

export default Footer;
